import React, { forwardRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { DropdownProps } from "./dropdown.interface";
import styles from "./index.module.scss";

const DropdownC = forwardRef((props: DropdownProps, ref: any) => {
  const {
    value,
    onChange,
    options,
    optionLabel,
    placeholder,
    className,
    panelClassName,
    tabIndex,
    border,
    showClear,
    selectColor,
    name,
    togglePanel,
    index,
    disabled
  } = props;
  const hasValue = !!value;

  return (
    <div
      className={`${styles.dropdownBox} ${
        border ? styles.dropdownBoxBorder : ""
      } ${selectColor && hasValue ? styles.selected : ""}`}
    >
      <Dropdown
        disabled={disabled}
        ref={ref}
        onClick={() => {
          if (togglePanel) {
            togglePanel(index);
          }
        }}
        value={value}
        onChange={onChange}
        name={name}
        options={options}
        optionLabel={optionLabel}
        placeholder={placeholder}
        className={className}
        panelClassName={panelClassName}
        tabIndex={tabIndex || 1}
        showClear={showClear}
      />
    </div>
  );
});

export default React.memo(DropdownC);
